import { render, staticRenderFns } from "./setting-financial-paypal.html?vue&type=template&id=737df78f&scoped=true&"
import script from "./setting-financial-paypal.js?vue&type=script&lang=js&"
export * from "./setting-financial-paypal.js?vue&type=script&lang=js&"
import style0 from "./setting-financial-paypal.scss?vue&type=style&index=0&id=737df78f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737df78f",
  null
  
)

export default component.exports